<script setup lang="ts">

defineOptions({
  name: 'TaskInfoList',
})

</script>

<template>
  <div class="task-info-list">
    <slot />
  </div>
</template>

<style scoped lang="scss" src="./TaskInfoList.scss" />
